/**
 * Kayer.pl — формат VAT/NIP по рынку (Shopify Markets).
 * PL: опционально PL, далее 10 цифр NIP (контрольная сумма).
 * Все остальные страны: обязателен префикс ISO2 (для GR допускается EL — как в VIES), затем национальная часть нужной длины.
 * window.kayerVatIdFormatOk(countryIso, rawValue) → boolean
 */
(function (global) {
  'use strict';

  function normalize(raw) {
    return String(raw || '')
      .replace(/[\s.\-\u00a0\u200b]/g, '')
      .replace(/^VAT:/i, '')
      .toUpperCase();
  }

  function digitsOnly(s) {
    return String(s || '').replace(/\D/g, '');
  }

  /** Польский NIP: опционально PL, ровно 10 цифр с контрольной суммой */
  function plNipChecksum(d10) {
    if (!/^\d{10}$/.test(d10)) return false;
    var weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    var sum = 0;
    for (var i = 0; i < 9; i++) sum += weights[i] * parseInt(d10.charAt(i), 10);
    var control = sum % 11;
    if (control === 10) return false;
    return control === parseInt(d10.charAt(9), 10);
  }

  function validPl(s) {
    var n = normalize(s);
    /** Не принимать DE…, HR… и т.п. как польский NIP (только цифры или PL+цифры). */
    if (/^[A-Z]{2}/.test(n) && n.indexOf('PL') !== 0) return false;
    if (n.indexOf('PL') === 0) n = n.slice(2);
    var d = digitsOnly(n);
    if (!/^\d{10}$/.test(d)) return false;
    return plNipChecksum(d);
  }

  /** Префиксы VAT, по которым можно понять страну, даже если localization = PL */
  var PREFIX_TO_CC = {
    PL: 'PL',
    FI: 'FI',
    HR: 'HR',
    CZ: 'CZ',
    SK: 'SK',
    IT: 'IT',
    IE: 'IE',
    GR: 'GR',
    ME: 'ME',
    EL: 'GR',
  };

  /**
   * Эффективная страна для проверки: явный ISO в номере (HR…, EL…) или рынок из корзины.
   */
  function resolveVatCountryIso(marketIso, raw) {
    var n = normalize(raw);
    if (!n) return String(marketIso || 'PL').toUpperCase().slice(0, 2);
    if (n.indexOf('EL') === 0 && n.length > 2 && /[0-9]/.test(n.charAt(2))) return 'GR';
    var two = n.slice(0, 2);
    if (PREFIX_TO_CC[two] && n.length > 2) {
      var third = n.charAt(2);
      if (/[0-9A-Z]/i.test(third)) return PREFIX_TO_CC[two];
    }
    return String(marketIso || 'PL').toUpperCase().slice(0, 2);
  }

  /** Обязателен префикс cc; вернуть национальную часть (без префикса) или null */
  function nationalAfterPrefix(n, cc) {
    if (!n || !cc) return null;
    if (cc === 'GR') {
      if (n.indexOf('GR') === 0) return n.slice(2);
      if (n.indexOf('EL') === 0) return n.slice(2);
      return null;
    }
    if (n.indexOf(cc) !== 0) return null;
    return n.slice(2);
  }

  function hrOib11(d11) {
    if (!/^\d{11}$/.test(d11)) return false;
    var a = 10;
    for (var i = 0; i < 10; i++) {
      a = (a + parseInt(d11.charAt(i), 10)) % 10;
      if (a === 0) a = 10;
      a = (a * 2) % 11;
    }
    var check = (11 - a) % 10;
    return check === parseInt(d11.charAt(10), 10);
  }

  function validHr(s) {
    var n = normalize(s);
    var rest = nationalAfterPrefix(n, 'HR');
    if (rest === null) return false;
    var d = digitsOnly(rest);
    return d.length === 11 && hrOib11(d);
  }

  /** CZ: CZ + 8, 9 или 10 цифр (национальная часть) */
  function validCz(s) {
    var n = normalize(s);
    var rest = nationalAfterPrefix(n, 'CZ');
    if (rest === null) return false;
    var d = digitsOnly(rest);
    return /^[0-9]+$/.test(d) && d.length >= 8 && d.length <= 10;
  }

  /** SK: SK + ровно 10 цифр */
  function validSk(s) {
    var n = normalize(s);
    var rest = nationalAfterPrefix(n, 'SK');
    if (rest === null) return false;
    var d = digitsOnly(rest);
    return d.length === 10 && /^\d{10}$/.test(d);
  }

  /** IT: IT + ровно 11 цифр (Partita IVA, упрощённо) */
  function validIt(s) {
    var n = normalize(s);
    var rest = nationalAfterPrefix(n, 'IT');
    if (rest === null) return false;
    var d = digitsOnly(rest);
    return d.length === 11 && /^\d{11}$/.test(d);
  }

  /**
   * IE: IE + 7–9 digits + optional 1–2 letters (A–W).
   * Second letter must allow A–W (check char), not only A–F — e.g. IE3211457EH.
   */
  function validIe(s) {
    var n = normalize(s);
    var rest = nationalAfterPrefix(n, 'IE');
    if (rest === null) return false;
    var t = rest.replace(/[^0-9A-Z]/gi, '').toUpperCase();
    return /^[0-9]{7,9}[A-W]{0,2}$/.test(t);
  }

  /** GR: GR или EL + ровно 9 цифр */
  function validGr(s) {
    var n = normalize(s);
    var rest = nationalAfterPrefix(n, 'GR');
    if (rest === null) return false;
    var d = digitsOnly(rest);
    return d.length === 9 && /^\d{9}$/.test(d);
  }

  /** ME: ME + 8 или 9 цифр */
  function validMe(s) {
    var n = normalize(s);
    var rest = nationalAfterPrefix(n, 'ME');
    if (rest === null) return false;
    var d = digitsOnly(rest);
    return (d.length === 8 || d.length === 9) && /^\d+$/.test(d);
  }

  /** FI: FI + ровно 8 цифр */
  function validFi(s) {
    var n = normalize(s);
    var rest = nationalAfterPrefix(n, 'FI');
    if (rest === null) return false;
    var d = digitsOnly(rest);
    return d.length === 8 && /^\d{8}$/.test(d);
  }

  /** AT, DE, FR, …: префикс = код страны рынка, дальше 8–12 символов [A-Z0-9] */
  function validEuPrefixed(cc, s) {
    var n = normalize(s);
    var rest = nationalAfterPrefix(n, cc);
    if (rest === null) return false;
    var body = rest.replace(/[^A-Z0-9]/gi, '').toUpperCase();
    return body.length >= 8 && body.length <= 12;
  }

  var byCountry = {
    PL: validPl,
    HR: validHr,
    CZ: validCz,
    SK: validSk,
    IT: validIt,
    IE: validIe,
    GR: validGr,
    ME: validMe,
    FI: validFi,
  };

  function validForMarket(countryIso, raw) {
    var cc = resolveVatCountryIso(countryIso, raw);
    if (!/^[A-Z]{2}$/.test(cc)) return false;
    var fn = byCountry[cc];
    if (fn) return fn(raw);
    return validEuPrefixed(cc, raw);
  }

  function getCartMarketCountryIso() {
    var el = document.getElementById('kayer-cart-market');
    if (!el) return 'PL';
    try {
      var j = JSON.parse(el.textContent);
      var c = (j.country_iso || j.country || 'PL').toString().toUpperCase().slice(0, 2);
      return c || 'PL';
    } catch (e) {
      return 'PL';
    }
  }

  global.kayerVatIdFormatOk = validForMarket;
  global.kayerGetCartMarketCountryIso = getCartMarketCountryIso;
  global.kayerResolveVatCountryIso = resolveVatCountryIso;
})(typeof window !== 'undefined' ? window : this);
